/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Schedule_BodyInputs */

const en_pricing_page_schedule_body = /** @type {(inputs: Pricing_Page_Schedule_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients take free hours on their own, and you see the whole week on your laptop and today on your phone.`)
};

const pl_pricing_page_schedule_body = /** @type {(inputs: Pricing_Page_Schedule_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podopieczni biorą wolne godziny sami, a Ty widzisz cały tydzień na laptopie i dzisiejszy dzień w telefonie.`)
};

/**
* | output |
* | --- |
* | "Clients take free hours on their own, and you see the whole week on your laptop and today on your phone." |
*
* @param {Pricing_Page_Schedule_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_schedule_body = /** @type {((inputs?: Pricing_Page_Schedule_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Schedule_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_schedule_body(inputs)
	return en_pricing_page_schedule_body(inputs)
});